var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58268 18.1244C4.87435 18.1244 1.04102 14.291 1.04102 9.58268C1.04102 4.87435 4.87435 1.04102 9.58268 1.04102C14.291 1.04102 18.1244 4.87435 18.1244 9.58268C18.1244 14.291 14.291 18.1244 9.58268 18.1244ZM9.58268 2.29102C5.55768 2.29102 2.29102 5.56602 2.29102 9.58268C2.29102 13.5994 5.55768 16.8744 9.58268 16.8744C13.6077 16.8744 16.8744 13.5994 16.8744 9.58268C16.8744 5.56602 13.6077 2.29102 9.58268 2.29102Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3326 18.9576C18.1742 18.9576 18.0159 18.8992 17.8909 18.7742L16.2242 17.1076C15.9826 16.8659 15.9826 16.4659 16.2242 16.2242C16.4659 15.9826 16.8659 15.9826 17.1076 16.2242L18.7742 17.8909C19.0159 18.1326 19.0159 18.5326 18.7742 18.7742C18.6492 18.8992 18.4909 18.9576 18.3326 18.9576Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrayIcon);
export default __webpack_public_path__ + "static/media/search_gray_icon.7bd6cd573a56a503542bb072f329e3f5.svg";
export { ForwardRef as ReactComponent };